import { createContext } from 'react';

const ThemedContext = /*#__PURE__*/createContext({
  isDark: true // default value
});

export { ThemedContext };
